import React from 'react';
import { Wrap, EasyActions, EasyWin, Loader } from '../../components/index';
import * as _ from 'lodash';
import { useResponsivity } from '../../helpers/helpers';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface ToiletsProps {
  challenges: any;
  listLocation: any;
  getChallengeCategory: Function;
  completeTask: any;
  completeChallenge: Function;
  generalData: Function;
  getOffers: Function;
}

const Shower: React.FC<ToiletsProps> = (props) => {
  const {
    challenges,
    getChallengeCategory,
    completeTask,
    completeChallenge,
    generalData,
    getOffers,
  } = props;
  const getRoomId = store('property');
  const loadingChallenges = _.get(challenges, 'status.loading');
  const data = _.get(challenges, 'data.challenges');
  const offers = _.get(challenges, 'offers.data.challenges');

  const isMobile = useResponsivity();
  const plumberVisit = _.find(offers, function (o) {
    return o.tag.includes('PLUMBER_VISIT');
  });

  const [t] = useTranslation('common');
  const { error, loading, done } = _.get(completeTask, 'status');
  React.useEffect(() => {
    getChallengeCategory(getRoomId, 'bathroom-shower');
    getOffers(getRoomId);
  }, [getRoomId]);
  const pageArray = [
    {
      id: 266,
      title: 'Showers',
      icon: 'shower',
      description:
        'Showers can account for high water and energy consumption owing to the amount of water flowing per minute, and length of time of each shower.',
      easyWins: [
        {
          title: 'Engage staff',
          size: 'half',
          hasLogo: false,
          description: [
            'Print off the poster and place within each shower area to remind users to take a short shower. This poster will help reduce cold & hot water use in your business by as much as 30%.',
          ],
          buttonText: 'Download PDF',
          buttonIcon: 'download',
          linkType: 'button',
          buttonPath:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/monkey.pdf',
          poster:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/monkey.png',
        },
        {
          title: 'Tell us your achievements',
          description: [
            'Confirm which actions you’ve completed to see how much water and money we think you’ll save.',
          ],
          theme: 'blue',
          size: 'half',
          hasLogo: false,
          isEasyAction: true,
        },
        {
          title: 'Plumber Tips',
          size: 'half',
          icon: 'sink',
          hasLogo: false,
          description: [
            'Ensure push button showers operate for no more than 30 seconds with each press. Percussion showers that run for longer may keep showers running after staff have finished their shower. Remember that wasted hot water will impact on your business energy bills, too.',
            'Your Facilities Manager or Plumber will be able to adjust the timing, if required.',
          ],
        },
        {
          title: 'Fix a leak',
          size: 'half',
          hasLogo: false,
          icon: 'fixLeak',
          buttonText:
            plumberVisit !== undefined
              ? 'Book a Free plumber visit'
              : 'Find a plumber',
          linkType:
            plumberVisit !== undefined ? 'internalLink' : 'externalLink',
          buttonPath:
            plumberVisit !== undefined
              ? '/actions'
              : 'https://www.watersafe.org.uk',
          buttonIcon: null,
          description: [
            'It’s important to check showers regularly. If a shower is dripping, then it’s worth fixing. Even a seemingly infrequent drip can waste almost 20,000 litres over 12 months if left unchecked.',
          ],
        },

        {
          title: 'Smart products',
          theme: 'green',
          size: 'full',
          hasLogo: true,
          icon: null,
          buttonText: 'Find water efficient showers',
          buttonPath: 'https://uk.getwatersmart.com/products?category=Showers',
          linkType: 'externalLink',
          description: [
            'Reduce cold & hot water use by switching your showers to operate by push button or similar timed mechanism. Unlike conventional showers, which require the user to manually turn off the water flow, push button showers provide only the amount of water required. They also minimise the risk of showers being left on overnight or at weekends.',
            'Push button operated showers produce a timed flow of water i.e. up to 30 seconds before the shower turns off automatically (the user can push the button as many times as they require).',
            'This type of shower can also allow water temperature to be pre-set, helping to manage energy used to heat the water.',
          ],
        },
      ],
    },
  ];

  const getChallenges = () => {
    return _.map(data, (el, index) => {
      const title = _.get(el, 'title');
      const description = _.get(el, 'description');
      const buttonText = _.get(el, 'buttonText');
      const type = _.get(el, 'internalType');
      const buttonPath = _.get(el, 'buttonPath');
      const energySaving = _.get(el, 'energy_saving');
      const carbonSaving = _.get(el, 'carbon_saving');
      const waterSaving = _.get(el, 'water_saving');
      const exType = _.get(el, 'type');
      return (
        <Col xs={12} sm={12} md={12} key={index}>
          <EasyActions
            isDesktop={!isMobile}
            icon={_.get(el, 'icon')}
            id={_.get(el, 'id')}
            title={`${t(title)}`}
            description={`${t(description)}`}
            buttonText={`${t(buttonText)}`}
            buttonPath={buttonPath}
            popup={type === 'direct-redirect' ? false : true}
            renderComplete={() => {
              completeChallenge(getRoomId, _.get(el, 'id'));
              setTimeout(() => {
                getChallengeCategory(getRoomId, 'toilets');
                generalData();
              }, 1000);
            }}
            isLoading={loading}
            completed={done}
            energySaving={energySaving}
            carbonSaving={carbonSaving}
            waterSaving={waterSaving}
            type={exType}
          />
        </Col>
      );
    });
  };
  if (loadingChallenges) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }
  return (
    <Wrap>
      <EasyWin data={pageArray}>
        <Row style={{ marginTop: '16px' }}>{getChallenges()}</Row>
      </EasyWin>
    </Wrap>
  );
};

export default Shower;
